<template>
    <modal name="morda-lenta-buy" @before-open="beforeOpen" @before-close="beforeClose" :classes="[
        'modal',
        'morda-lenta-modal',
        'v--modal',
        'error-modal',
        hasBugs && 'has-bugs',
    ]" :width="730" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">{{ $t("mordaLentaBuy.getPhotoFilm") }}</div>
        <div class="modal-close" @click="close"></div>
        <div v-if="!initIsEmpty('init') && counts" class="modal-body">
            <div class="modal-subtitle">
                {{ $t("mordaLentaBuy.selectPhotoFilm") }}
            </div>
            <ul class="morda-lenta-count-list">
                <li v-for="(count, index) in counts" class="morda-lenta-count-item" :key="index"
                    :class="'morda-lenta-count-' + count.count">
                    <div v-if="countIndex != index">
                        <span @click="countIndex = index" class="morda-lenta-count-text">
                            {{ count.count }}
                            {{
                                declineNouns(counts[countIndex].count,
                                    [
                                        $t("mordaLentaBuy.card"),
                                        $t("mordaLentaBuy.cards"),
                                        $t("mordaLentaBuy.cardd")
                                    ])
                            }}
                        </span>
                        <br />
                        <span class="morda-lenta-count-price">{{ count.price }}</span>
                    </div>
                    <div v-else class="morda-lenta-selected"></div>
                </li>
            </ul>
            <div class="form-item morda-lenta-form-item">
                <textarea v-model="text" name="text" placeholder="Добавьте сообщение на карту" :maxlength="60"
                    class="textarea morda-lenta-textarea" :class="{ 'field-error': errors.has('text') }"></textarea>
            </div>
            <div class="modal-buy-summary">
                <div class="modal-buy-total">
                    {{ counts[countIndex].count }}
                    <!-- {{
                        declineNouns(counts[countIndex].count, ["карта", "карты", "карт"])
                    }} -->
                    {{
                        declineNouns(counts[countIndex].count,
                            [
                                $t("mordaLentaBuy.card"),
                                $t("mordaLentaBuy.cards"),
                                $t("mordaLentaBuy.cardd")
                            ])
                    }}
                    {{ $t("mordaLentaBuy.inFavourOf") }}
                    {{ counts[countIndex].price }}
                    <!-- {{
                        declineNouns(counts[countIndex].price, [
                            "зарик",
                            "зарика",
                            "зариков",
                        ])
                    }} -->
                    {{
                        declineNouns(counts[countIndex].price,
                            [
                                $t("photoDetails.zarik"),
                                $t("photoDetails.zarika"),
                                $t("photoDetails.zarikov")
                            ])
                    }}
                </div>
                <div v-if="parseFloat(user.balance) < parseFloat(counts[countIndex].price)" class="modal-buy-balance">
                    <span class="text-warning">{{ $t("roulette.notEnoughFunds") }},</span>
                    <span @click="$modal.show('balance-in')" class="link-underlined">{{ $t("roulette.refill") }}</span>
                </div>
            </div>
            <div class="modal-footer buttons-row">
                <button @click="close" class="button-secondary">{{ $t("stories.cancel") }}</button>
                <button @click="confirm" class="button" :class="{ 'button-loader': loader }">
                    {{ $t("stories.continue") }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "MordaLentaBuy",
    props: {
        i18n: Object,
    },

    mixins: [declineNouns, checkScroll],
    data() {
        return {
            hasBugs: false,
            countIndex: 0,
            loader: false,
            text: "",
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            mordaLenta: "mordaLenta/getMordaLenta",
            mordaLentaErrors: "mordaLenta/errors",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
        counts() {
            return [
                {
                    count: 1,
                    price: this.formatPrice(this.init.costs.mordalenta_one_card_price),
                },
                {
                    count: 3,
                    price: this.formatPrice(this.init.costs.mordalenta_three_cards_price),
                },
                {
                    count: 6,
                    price: this.formatPrice(this.init.costs.mordalenta_six_cards_price),
                },
                {
                    count: 9,
                    price: this.formatPrice(this.init.costs.mordalenta_nine_cards_price),
                },
            ];
        },
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.$modal.hide("morda-lenta-buy");
            }
        },
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
            document
                .getElementsByTagName("body")[0]
                .classList.add("morda-lenta-body");
        },
        beforeClose() {
            this.checkRemoveScroll();
            document
                .getElementsByTagName("body")[0]
                .classList.remove("morda-lenta-body");
        },
        confirm() {
            if (
                parseInt(this.user.balance) >=
                parseInt(this.counts[this.countIndex].price)
            ) {
                this.loader = true;
                const data = {
                    count: this.counts[this.countIndex].count,
                    text: this.text,
                };
                this.$store
                    .dispatch("mordaLenta/buy", data)
                    .then(() => {
                        this.loader = false;
                        this.text = "";
                        this.$modal.hide("morda-lenta-buy");
                    })
                    .catch(() => {
                        this.loader = false;
                        for (let key in this.mordaLentaErrors) {
                            this.errors.add({
                                field: key,
                                msg: this.mordaLentaErrors[key][0],
                            });
                        }
                    });
            }
        },
        formatPrice(price) {
            if (this.user.vip) {
                return Math.ceil((price * (100 - this.init.costs.vip_discount)) / 100);
            }
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        close() {
            this.$modal.hide("morda-lenta-buy");
        },
    },
};
</script>
